import React, { lazy } from "react";
import { Route } from "react-router-dom";

const VehicleList = lazy(() => import("../pages/vehiclePages/vehicleList"));
const VehicleCardLimit = lazy(() => import("../pages/vehiclePages/vehicleCardLimit"));
const AddNewVehicles = lazy(() => import("../pages/vehiclePages/addNewVehicles"));
const EditVehicle = lazy(() => import("../pages/vehiclePages/editVehicle"));
const VehiclesCurrentLimit = lazy(() => import("../pages/vehiclePages/vehicleCurrentLimit"));

const VehicleRoutes = [
    <Route exact path="/vehicleList" component={VehicleList} />,
    <Route exact path="/vehicleCardLimit" component={VehicleCardLimit} />,
    <Route exact path="/vehicleList/addNewVehicles" component={AddNewVehicles} />,
    <Route
        exact
        path={["/vehicleList/editVehicle", "/vehicleList/editVehicle/:Id"]}
        component={EditVehicle}
    />,
    <Route exact path="/vehicleCardLimit/vehiclesCurrentLimit" component={VehiclesCurrentLimit} />
];

export default VehicleRoutes;
